<mat-toolbar class="p-0 mat-elevation-z1">
    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
            <button
                [id]="'button_toolbar_ToggleMenu'"
                mat-icon-button
                class="navbar-toggle-button"
                *ngIf="!hiddenNavbar && !rightNavbar"
                (click)="toggleSidebarOpen('navbar')"
                fxHide.gt-md
            >
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/icons/icon_gurumatch_branco.png" />
                </div>
            </div>

            <div class="px-8 px-md-16">
                <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
            </div>
        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
            <button [id]="'button_toolbar_UserMenu'" mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="username mr-12">{{ userName | truncate: [25, "..."] }}</span>
                    <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
                <button
                    [id]="'button_toolbar_subscriptionMenu'"
                    fxHide.gt-xs
                    fxLayoutAlign="start"
                    mat-menu-item
                    [matMenuTriggerFor]="subscriptionMenu"
                    *ngIf="showSubscriptionSelector"
                >
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <span class="username">{{ currentSubscription.name }}</span>
                    </div>
                </button>

                <button
                    [id]="'button_toolbar_LanguageMenu'"
                    fxHide.gt-xs
                    fxLayoutAlign="start"
                    mat-menu-item
                    [matMenuTriggerFor]="languageMenu"
                >
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <img class="flag mr-8" [src]="'assets/icons/flags/' + selectedLanguage.flag + '.png'" />
                        <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
                    </div>
                </button>

                <button mat-menu-item class="help-button" (click)="helpClick()" fxHide.gt-xs>
                    <mat-icon>help_center</mat-icon>
                    <span>{{ "TOOLBAR.HELP" | translate }}</span>
                </button>

                <button [id]="'button_toolbar_Logout'" mat-menu-item class="" (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>{{ "TOOLBAR.LOGOUT" | translate }}</span>
                </button>
            </mat-menu>

            <div class="toolbar-separator" *ngIf="showSubscriptionSelector"></div>

            <button
                [id]="'button_toolbar_subscriptionMenu'"
                mat-button
                [matMenuTriggerFor]="subscriptionMenu"
                class="user-button"
                *ngIf="showSubscriptionSelector"
                fxHide.xs
            >
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="username mr-12">{{ currentSubscription.name }}</span>
                    <mat-icon class="s-16">keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #subscriptionMenu="matMenu" [overlapTrigger]="false">
                <mat-form-field mat-menu-item style="padding: 0">
                    <input
                        #search
                        matInput
                        [placeholder]="'BUSCA' | translate"
                        (input)="search$.next(search.value)"
                        (click)="$event.stopPropagation()"
                        class="search-subcription"
                    />
                </mat-form-field>
                <button
                    [id]="'button_toolbar_Logout'"
                    mat-menu-item
                    class=""
                    (click)="switchSubscription(item)"
                    *ngFor="let item of subscriptionsData.data"
                >
                    <span>{{ item.name }}</span>
                </button>
                <div class="w-100-p" fxLayoutAlign="center" *ngIf="subscriptionsData.totalRows > 10">
                    <span>Resultados ocultos,<br />melhore o filtro</span>
                </div>
            </mat-menu>

            <div class="toolbar-separator"></div>

            <button mat-icon-button class="help-button" (click)="helpClick()" fxHide.xs>
                <mat-icon>help_center</mat-icon>
            </button>

            <!-- <fuse-search-bar (input)="search($event)"></fuse-search-bar> -->

            <div class="toolbar-separator"></div>

            <button
                [id]="'button_toolbar_LanguageMenu'"
                mat-button
                fxHide
                fxShow.gt-xs
                class="language-button"
                [matMenuTriggerFor]="languageMenu"
            >
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/icons/flags/' + selectedLanguage.flag + '.png'" />
                    <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
                <button
                    [id]="'button_toolbar_Language'"
                    mat-menu-item
                    *ngFor="let lang of languages"
                    (click)="setLanguage(lang)"
                >
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" [src]="'assets/icons/flags/' + lang.flag + '.png'" />
                        <span class="iso">{{ lang.title }}</span>
                    </span>
                </button>
            </mat-menu>

            <!-- <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button [id]="'button_toolbar'" mat-icon-button
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    aria-label="Toggle quick panel">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button [id]="'button_toolbar'" mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button> -->
        </div>
    </div>
</mat-toolbar>
